import React, { forwardRef, useContext, useMemo, useState } from 'react';

import get from 'lodash-es/get';

import { OVCStoreDataContext } from 'return-portal-ui';

const TRESHOLD_VALUE = 1.25;

const HeaderLogo = forwardRef<HTMLAnchorElement | HTMLDivElement>((props, ref) => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  const context = useContext(OVCStoreDataContext);

  const storeUrlHref = useMemo(() => {
    const rawUrl = get(context.storeData, 'url', '') || '';

    if (rawUrl === '') {
      return '/';
    }

    try {
      let urlObj;
      if (rawUrl.indexOf('http') === -1) {
        urlObj = new URL(`https://${rawUrl}`);
      } else {
        urlObj = new URL(rawUrl);
      }
      return urlObj.toString();
    } catch (err) {
      return '/';
    }
  }, [context.storeData]);

  const generalHeight = dimensions.width / dimensions.height > TRESHOLD_VALUE ? '28px' : '56px';

  if (context.storeData.portalSettings.logo || context.storeData.portalV2?.logo) {
    return (
      <div style={{ height: generalHeight }}>
        <a
          href={storeUrlHref}
          target="_blank"
          rel="noreferrer noopener"
          ref={ref as React.Ref<HTMLAnchorElement>}
        >
          <img
            style={{
              width: 'auto',
              height: generalHeight,
              visibility: dimensions.width ? 'visible' : 'hidden',
            }}
            src={context.storeData.portalV2?.logo || context.storeData.portalSettings.logo || ''}
            alt={context.storeData.name || context.storeData.slug}
            onLoad={(e) => {
              const { naturalWidth, naturalHeight } = e.currentTarget;
              setDimensions({ width: naturalWidth, height: naturalHeight });
            }}
          />
        </a>
      </div>
    );
  }

  return (
    <div
      className="h-[28px]"
      data-cy="ovc-layout-header-logo-outvio"
      ref={ref as React.Ref<HTMLDivElement>}
    />
  );
});

export default HeaderLogo;
